import {
  TableBody as ShadcnTableBody,
  TableCell as ShadcnTableCell,
  TableRow as ShadcnTableRow,
} from '@shadcn/ui/table';
import { Row, flexRender, ColumnDef } from '@tanstack/react-table';
import React from 'react';

import { TABLE_CONSTANTS } from '../constants';

interface ITableBodyProps<TData> {
  readonly rows: Row<TData>[];
  readonly columns: ColumnDef<TData>[];
  readonly loading?: boolean;
}

export function TableBody<TData>({ rows, columns, loading }: ITableBodyProps<TData>) {
  const { STYLING } = TABLE_CONSTANTS;

  if (loading || !rows.length) {
    return (
      <ShadcnTableBody>
        <ShadcnTableRow>
          <ShadcnTableCell className={`h-24 text-center ${STYLING.COLORS.TEXT}`} colSpan={columns.length}>
            {loading && 'Loading...'}
            {!loading && !rows.length && ' No results.'}
          </ShadcnTableCell>
        </ShadcnTableRow>
      </ShadcnTableBody>
    );
  }

  return (
    <ShadcnTableBody>
      {rows.map((row, rowIndex) => {
        const isLastRow = rowIndex === rows.length - 1;

        return (
          <ShadcnTableRow key={row.id}>
            {row.getVisibleCells().map((cell) => (
              <ShadcnTableCell
                className={`${STYLING.COLORS.TEXT} text-md break-words
                  ${STYLING.CELL_PADDING.TOP} ${STYLING.CELL_PADDING.BOTTOM} 
                  ${STYLING.CELL_PADDING.LEFT} ${STYLING.CELL_PADDING.RIGHT} 
                  ${isLastRow ? STYLING.BORDERS.CELL : ''}`}
                key={cell.id}
              >
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </ShadcnTableCell>
            ))}
          </ShadcnTableRow>
        );
      })}
    </ShadcnTableBody>
  );
}
